import { ErrorSidePanel } from '@/components/errors';
import { useGetPersonalInfo } from '@/hooks/api';
import { templates, type SkinPageConfig } from '@nosinovacao/nosid-mfe-common';
import { createFileRoute } from '@tanstack/react-router';
import { useGetLoginOptions } from '../../../../-hooks/login-options.hook';
import { type LandingPageProps } from './-model/props';
import { LandingPageLight } from './-skins';

export const Route = createFileRoute(
  '/(home)/home/(change-contacts)/_sheet/change-contacts/(landing-page)/',
)({
  component: RouteComponent,
  errorComponent: ErrorSidePanel,
});

function RouteComponent() {
  const { isLoading } = useGetPersonalInfo();
  const { data: loginOptions } = useGetLoginOptions();

  const hasUsername = !!loginOptions?.UsernameAliases.some((alias) => alias.Type === 'Other');

  const props: LandingPageProps = {
    isLoading,
    hasUsername,
  };
  return templates.getSkinSelector(skinConfig(props));
}

export function skinConfig(props: LandingPageProps): SkinPageConfig {
  return {
    skins: [],
    defaultValue: <LandingPageLight {...props} />,
  };
}
